// possible fix is to use this https://github.com/reactrondev/react-native-web-swiper

import ImageGalleryForWeb from './web-components/ImageGalleryForWeb'

export default ImageGalleryForWeb
